// V2 photo cards: warm their images near the section and fit the active card.
(() => {
  const track = document.querySelector('.dp-social-track');
  if (!track) return;
  const cards = [...track.querySelectorAll('.dp-social-card')];
  if (!cards.length) return;
  let frame = 0;
  const fit = () => {
    frame = 0;
    const edge = parseFloat(getComputedStyle(track).getPropertyValue('--dp-social-edge')) || 0;
    const left = track.getBoundingClientRect().left + edge;
    const active = cards.reduce((best, card) =>
      Math.abs(card.getBoundingClientRect().left - left) < Math.abs(best.getBoundingClientRect().left - left) ? card : best);
    track.style.setProperty('--v2-review-height', Math.ceil(active.getBoundingClientRect().height + 6) + 'px');
  };
  const schedule = () => { if (!frame) frame = requestAnimationFrame(fit); };
  const section = track.closest('.dp-social');
  // The shared legacy script writes the ingredient heading's styles inline.
  // Let the V2 section CSS own this heading after those legacy sync events.
  const title = section?.querySelector('#dp-social-title');
  const clearLegacyTitle = () => {
    if (!title) return;
    ['font-family', 'font-size', 'font-weight', 'line-height', 'letter-spacing', 'font-style', 'color']
      .forEach(property => title.style.removeProperty(property));
  };
  window.addEventListener('resize', clearLegacyTitle, { passive: true });
  document.fonts?.ready.then(clearLegacyTitle);
  clearLegacyTitle();
  const photos = cards.map(card => card.querySelector('.dp-social-comment img')).filter(Boolean);
  let warmed = false;
  const warmPhotos = () => {
    if (warmed) return;
    warmed = true;
    photos.forEach(photo => {
      photo.fetchPriority = 'low';
      photo.addEventListener('load', schedule, { once: true });
      photo.loading = 'eager';
    });
  };
  if ('IntersectionObserver' in window && section) {
    const near = new IntersectionObserver(entries => {
      if (!entries.some(entry => entry.isIntersecting)) return;
      warmPhotos();
      near.disconnect();
    }, { rootMargin: '1200px 0px' });
    near.observe(section);
    section.addEventListener('pointerdown', warmPhotos, { once: true, passive: true });
    section.addEventListener('focusin', warmPhotos, { once: true });
  } else {
    warmPhotos();
  }
  track.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  const observer = new ResizeObserver(schedule);
  cards.forEach(card => observer.observe(card));
  document.fonts?.ready.then(schedule);
  schedule();
})();

document.querySelector('.gno-faq')?.classList.add('v2-faq-clarity');

// The videos now live outside the hero; hydrate near them, retaining deferred media.
(() => {
  const init = () => document.querySelectorAll('gnd-video-stories').forEach(root => {
    if (root.dataset.oc25Observed) return;
    root.dataset.oc25Observed = 'true';
    let loading;
    const load = () => {
      root.querySelectorAll('video[data-poster]').forEach(video => { video.poster = video.dataset.poster; });
      if (customElements.get('gnd-video-stories')) return Promise.resolve();
      if (loading) return loading;
      loading = new Promise((resolve,reject) => {
        const script=document.createElement('script');script.src=root.dataset.script;script.dataset.gndVideoLoader='';
        script.onload=resolve;script.onerror=()=>{loading=null;script.remove();reject(new Error('Video controls unavailable'));};
        document.head.append(script);
      });
      return loading;
    };
    if ('IntersectionObserver' in window) {
      const observer=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting)){observer.disconnect();load().catch(()=>{});}},{rootMargin:'500px'});observer.observe(root);
    } else load().catch(()=>{});
    root.addEventListener('focusin',()=>load().catch(()=>{}),{once:true});
    root.addEventListener('pointerover',()=>load().catch(()=>{}),{once:true,passive:true});
    root.addEventListener('click',event=>{
      if(customElements.get('gnd-video-stories'))return;
      const button=event.target.closest('[data-video-play]');if(!button)return;
      event.preventDefault();event.stopImmediatePropagation();
      load().then(()=>button.click()).catch(()=>{button.querySelector('[data-play-text]').textContent=root.dataset.retryLabel;});
    },true);
  });
  init();document.addEventListener('shopify:section:load',init);
})();
